// src/types/wrap-up-api.ts
// Encounter Wrap-Up record (PatientEncouterWrapup). Mirrors the .NET WrapUpEncounterRequest DTO
// (Scrips.Patient Application/Dtos/PatientChart/WrapUpEncounterRequest.cs):
//   POST /api/Patients/CreateWrapUp        (body = WrapUpModel)
//   PUT  /api/Patients/UpdateWrapUp?id=    (body = WrapUpModel)
//   GET  /api/Patients/GetWrapUpByPatientId?patientId=&encounterId=
// On sign/lock the backend turns a non-zero followupCount into a follow-up appointment request
// (WrapUpService → AppointmentManagementService.CreateFollowupRequest → Scheduling gRPC).
export interface WrapUpModel {
  /** Wrap-up record id — present on an existing record (→ PUT update); absent → POST create. */
  id?: string | null;
  /** Patient id (DTO `Subject`). */
  subject?: string | null;
  /** Encounter id (DTO `Encounter`). */
  encounter?: string | null;
  /** Patient instructions (separate Wrap-Up slice; preserved on a follow-up-only save). */
  instructions?: string | null;
  notePlainText?: string | null;
  /** Follow-up count — a non-zero value schedules the next visit on sign/lock. */
  followupCount?: number | null;
  /** Follow-up time unit — one of FOLLOWUP_UNITS. */
  followupCountUnit?: string | null;
  isDeleted?: boolean | null;
}

/** The follow-up time units (Flutter `app_constants.dart:360 durationUnitFollowup`). */
export const FOLLOWUP_UNITS = ['Days', 'Weeks', 'Months', 'Years'] as const;
export type FollowUpUnit = (typeof FOLLOWUP_UNITS)[number];
